import { configureStore } from "@reduxjs/toolkit";
import projectsReducer from "./projects/projectsSlice";
import filtersReducer from "./filters/filtersSlice";

export const store = configureStore({
  reducer: {
    projects: projectsReducer,
    filters: filtersReducer,
  },
});
